/**
 * メッセージ・タスクAPI実装
 *
 * バックエンドAPIに接続して、メッセージとタスクを管理します。
 */

import { httpClient } from '@src/api/core';
import type {
  ErrorResponse,
  GetMessagesResponse,
  GetTasksResponse,
  MarkMessageAsReadRequest,
  MarkMessageAsReadResponse,
} from '@src/types/shared/api/message_task_api';

/**
 * メッセージ一覧を取得
 */
export async function getMessages(): Promise<GetMessagesResponse> {
  try {
    return await httpClient.get<GetMessagesResponse>('api/v1/messages');
  } catch (error) {
    console.error('Failed to fetch messages:', error);
    throw error;
  }
}

/**
 * タスク一覧を取得
 */
export async function getTasks(): Promise<GetTasksResponse> {
  try {
    return await httpClient.get<GetTasksResponse>('api/v1/tasks');
  } catch (error) {
    console.error('Failed to fetch tasks:', error);
    throw error;
  }
}

/**
 * メッセージを既読にする
 */
export async function markMessageAsRead(
  request: MarkMessageAsReadRequest
): Promise<MarkMessageAsReadResponse | ErrorResponse> {
  try {
    return await httpClient.patch<MarkMessageAsReadResponse>(
      `api/v1/messages/${request.messageId}/read-status`,
      { isRead: true }
    );
  } catch (error) {
    console.error('Failed to mark message as read:', error);
    throw error;
  }
}
